const TIMEOUT_MS  = 25 * 60 * 1000; // 25 min
const WARNING_MS  = 5 * 60 * 1000;  // 5 min
const STORAGE_KEY = "lastActivityAt";
const LOGOUT_KEY  = "forcedLogoutAt"; 
const CHANNEL     = "inactivity-sync";
 
export function startInactivityWatch(onReauth, onWarn) {
  let bc = (typeof BroadcastChannel !== "undefined") ? new BroadcastChannel(CHANNEL) : null;
  let warned = false;
  let stopped = false;
 
  const setLastActivity = (ts) => {
    if (stopped) return;
    const now = typeof ts === "number" ? ts : Date.now();
    try {
      localStorage.setItem(STORAGE_KEY, String(now));
    } catch (e) {
      console.warn("Failed to access localStorage:", e);
    }
    if (bc) {
      try { bc.postMessage({ type: "activity", ts: now }); }
      catch (e) { console.warn("BroadcastChannel postMessage failed:", e); }
    }
  };
 
  const getLastActivity = () => {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? Number(raw) : 0;
  };
 
  const markActive = () => {
    warned = false;
    setLastActivity();
  } 
 
  const activityEvents = ["click","keydown","mousemove","scroll","touchstart"];
  activityEvents.forEach(ev => window.addEventListener(ev, markActive, { passive:true }));
 
  const onVisibility = () => { if (!document.hidden) markActive(); };
  document.addEventListener("visibilitychange", onVisibility);
 
  if (bc) {
    bc.addEventListener("message", (e) => {
      if (stopped || !e?.data) return;
      if (e.data.type === "activity") {
        try { localStorage.setItem(STORAGE_KEY, String(e.data.ts)); }
        catch (err) { console.warn("Failed to access localStorage:", err); }
      } else if (e.data.type === "force-logout") {
        cleanup();
        onReauth(); 
      }
    });
  }
 
  const onStorage = (ev) => {
    if (stopped) return;
    if (ev.key === LOGOUT_KEY && ev.newValue) {
      cleanup();
      onReauth();
    }
  };
  window.addEventListener("storage", onStorage);
 
  if (!getLastActivity()) setLastActivity();
 
  const timer = window.setInterval(() => {
    if (stopped) return;
    const idle = Date.now() - getLastActivity();
 
    if (!warned && typeof onWarn === "function" &&
        idle >= (TIMEOUT_MS - WARNING_MS) && idle < TIMEOUT_MS) {
      warned = true;
      onWarn(() => {
        warned = false;
        markActive();
      });
    }
 
    if (idle >= TIMEOUT_MS) {
      try { localStorage.setItem(LOGOUT_KEY, String(Date.now())); } 
      catch (e) {
        console.warn("Failed to set forcedLogoutAt in localStorage:", e);
      }
      if (bc) {
        try { bc.postMessage({ type: "force-logout" }); } 
        catch (e) {
          console.warn("BroadcastChannel force-logout failed:", e);
        }
      }
      cleanup();
      onReauth();
    }
  }, 5000); 
 
  function cleanup() {
    if (stopped) return;
    stopped = true;
    window.clearInterval(timer);
    activityEvents.forEach(ev => window.removeEventListener(ev, markActive));
    document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("storage", onStorage);
    if (bc) {
      try { bc.close(); } catch (e) { console.warn("BroadcastChannel close failed", e); }
      bc = null;
    }
  }
 
  return { stop: cleanup, ping: markActive };
}